import { addLocale, locale as setPrimeReactLocale } from 'primereact/api';
import { t } from '../content';

/** Content keys → PrimeReact locale option ids. */
const TABLE_FILTER_TO_PRIME = {
  startsWith: 'startsWith',
  contains: 'contains',
  notContains: 'notContains',
  endsWith: 'endsWith',
  equals: 'equals',
  notEquals: 'notEquals',
  noFilter: 'noFilter',
  filter: 'filter',
  lessThan: 'lt',
  lessThanOrEqual: 'lte',
  greaterThan: 'gt',
  greaterThanOrEqual: 'gte',
  dateIs: 'dateIs',
  dateIsNot: 'dateIsNot',
  dateBefore: 'dateBefore',
  dateAfter: 'dateAfter',
  custom: 'custom',
  clear: 'clear',
  close: 'close',
  apply: 'apply',
  matchAll: 'matchAll',
  matchAny: 'matchAny',
  addRule: 'addRule',
  removeRule: 'removeRule',
  noResults: 'emptyMessage',
  noOptions: 'emptyFilterMessage',
};

export function applyPrimeReactLocale(appLocale) {
  const options = {};
  Object.entries(TABLE_FILTER_TO_PRIME).forEach(([contentKey, primeKey]) => {
    options[primeKey] = t(`common.tableFilter.${contentKey}`, {}, appLocale);
  });
  addLocale(appLocale, options);
  setPrimeReactLocale(appLocale);
}
